// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 870 ? "core_www" : chunkId) + "." + {"831":"3497722f","870":"72ddd52e"}[chunkId] + ".js";
};